//  export const ApiConnectionString = "https://localhost:7040"



export const ApiConnectionString = "https://neruodirectory-cze2egb0cpcdfwez.ukwest-01.azurewebsites.net"




